(function () {
  const template = document.body.getAttribute('data-template') || '';

  const TEMPLATE_PRESELECT = {
    // QR3
    "bike-rack-shop": "QR3",
    "qr3-fit-chart": "QR3",
    "qr3-crossbar-fit-guide": "QR3",
    "qr3-utrack-fit-guide": "QR3",
    "qr3-side-track-fit-guide": "QR3",
    "qr3-bike-rack": "QR3",
    "qr3-gmc-chevy-ev": "QR3",
    "qr3-oem-non-us": "QR3",
    "qr3-oem-us": "QR3",
    "qr3-ridgeline": "QR3",
    "qr3-telescopic-ford": "QR3",
    "qr3-telescopic-U.S.": "QR3",
    "qr3-toyota": "QR3",
    "qr3-track-adapters-nonus": "QR3",
    "qr3-track-adapters-U.S.": "QR3",
    "qr3-u-track-ranger": "QR3",
    "qr3-u-track-U.S.": "QR3",
    "qr3-universal-floor-kit": "QR3",
    "qr3-universal-wall-kit": "QR3",
    "qr3-utrack-non-U.S.": "QR3",
    "qr3-hanger": "QR3",

    // Cinch
    "shop-cinch-rack": "Cinch",
    "cinch-fit-chart": "Cinch",
    "cinch-crossbar-fit-guide": "Cinch",
    "cinch-utrack-fit-guide": "Cinch",
    "cinch-sidetrack-fit-guide": "Cinch",
    "cinch-gmc-chevy-ev": "Cinch",
    "cinch-oem-non-us": "Cinch",
    "cinch-oem-us": "Cinch",
    "cinch-ridgeline": "Cinch",
    "cinch-telescopic-ford": "Cinch",
    "cinch-telescopic-us": "Cinch",
    "cinch-track-adapters-us": "Cinch",
    "cinch-trck-adapters-nonus": "Cinch",
    "cinch-u-track-non-us": "Cinch",
    "cinch-u-track-ranger": "Cinch",
    "cinch-u-track-us": "Cinch",
    "cinch-hanger": "Cinch",

    // DECKED
    "shop-qr3-decked": "QR3 for DECKED",
    "shop-cinch-deck-box": "Cinch for DECKED"
  };

  const desired = TEMPLATE_PRESELECT[template];
  if (!desired) return;

  function normalize(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  function findRackTypeSelect() {
    const holder = document.querySelector(".easysearch-select-holder");
    if (holder) {
      const sel = holder.querySelector("select");
      if (sel) return sel;
    }
    return null;
  }

  function setSelectByLabelOrValue(select, labelWanted) {
    if (!select || !select.options || select.options.length === 0) return false;

    const wanted = normalize(labelWanted);

    const current = select.options[select.selectedIndex];
    if (current && normalize(current.textContent) === wanted) return true;

    let matchIndex = -1;
    for (let i = 0; i < select.options.length; i++) {
      const opt = select.options[i];
      if (!opt || opt.disabled) continue;
      if (normalize(opt.textContent) === wanted) {
        matchIndex = i;
        break;
      }
    }

    if (matchIndex === -1) {
      for (let i = 0; i < select.options.length; i++) {
        const opt = select.options[i];
        if (!opt || opt.disabled) continue;
        if (normalize(opt.value) === wanted) {
          matchIndex = i;
          break;
        }
      }
    }

    if (matchIndex === -1) return false;

    select.selectedIndex = matchIndex;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    select.dispatchEvent(new Event("input", { bubbles: true }));
    return true;
  }

  function init() {
    const rackSelect = findRackTypeSelect();
    if (rackSelect && setSelectByLabelOrValue(rackSelect, desired)) return;

    // Watch for the select to appear or get populated
    const observer = new MutationObserver(() => {
      const sel = findRackTypeSelect();
      if (sel && setSelectByLabelOrValue(sel, desired)) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Retry periodically in case widget loads async
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const sel = findRackTypeSelect();
      if (sel && setSelectByLabelOrValue(sel, desired)) {
        clearInterval(timer);
        observer.disconnect();
      }
      if (tries >= 20) {
        clearInterval(timer);
        observer.disconnect();
      }
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
